import styled from 'styled-components'
import { theme, progressiveBreakpoints } from '../../constants/theme'
import Crown from '../../static/images/crown.svg'

const Wrapper = styled.div`
  @media ${progressiveBreakpoints.desktopSmall} {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
`

const Stat = styled.div`
  background-color: ${theme.colors.background.backgroundColor};
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media ${progressiveBreakpoints.desktopSmall} {
    width: 48.7%;
  }

  @media ${progressiveBreakpoints.desktop} {
    flex-direction: row;
  }

  img {
    max-width: 178px;
    align-self: flex-end;
  }

  ${(props) =>
    props.hasImage &&
    `
    padding-bottom: 0;

    p {
      margin-bottom: 1.5rem;
    }
  `}

  ${(props) =>
    props.fullWidth &&
    `
    margin-top: 45px;
    position: relative;
    z-index: 2;

    strong {
      color: ${theme.colors.fonts.yellow};
    }

    &:before {
      content: '';
      background-image: url('${Crown}');
      background-repeat: no-repeat;
      width: 152px;
      height: 51px;
      position: absolute;
      top: -51px;
      right: 0;
      z-index: 1;
    }

    @media ${progressiveBreakpoints.desktopSmall} {
      width: 100%;

      p {
        font-size: 1.5rem;
        line-height: 1.17;
      }
    }
  `}
`

export { Wrapper, Stat }
